const PIM = "https://ofn.gov.cz/slovník/pim/";
export const HAS_TECHNICAL_LABEL = PIM + "technicalLabel";
export const HAS_INTERPRETATION = PIM + "hasInterpretation";
export const HAS_CLASS = PIM + "hasClass";
export const HAS_DATA_TYPE = PIM + "hasDatatype";
export const HAS_END = PIM + "hasEnd";
export const HAS_PARTICIPANT = PIM + "hasParticipant";
export const CLASS = PIM + "Class";
export const ATTRIBUTE = PIM + "Attribute";
export const ASSOCIATION = PIM + "Association";
export const ASSOCIATION_END = PIM + "AssociationEnd";
export const SCHEMA = PIM + "Schema";
export const HAS_ISA = PIM + "isa";
const DCTERMS = "http://purl.org/dc/terms/";
export const HAS_PART = DCTERMS + "hasPart";
export const HAS_HUMAN_LABEL = DCTERMS + "title";
export const HAS_HUMAN_DESCRIPTION = DCTERMS + "description";
//# sourceMappingURL=pim-vocabulary.js.map